(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-rec-data]').textContent);
    const current = data.products.find(p => p.handle === data.current);
    if (!current) return;
    const track = root.querySelector('.yiri-board-recs__track');
    const cards = new Map([...track.children].map(card => [card.dataset.recHandle, card]));
    const base = handle => handle.replace('-pattern-plus', '');
    const pattern = handle => handle.includes('-pattern-plus');
    const colorIndex = p => p.options.findIndex(o => /^(color|colour)$/i.test(o));
    const norm = v => String(v || '').trim().toLowerCase();
    function update(variantId) {
      const variant = current.variants.find(v => String(v.id) === String(variantId)) || current.variants.find(v => v.available) || current.variants[0];
      const color = norm(variant.options[colorIndex(current)]);
      const ranked = data.products.filter(p => p.handle !== current.handle).map(p => {
        const match = p.variants.find(v => v.available && color && norm(v.options[colorIndex(p)]) === color);
        const chosen = match || p.variants.find(v => v.available) || p.variants[0];
        const paired = base(p.handle) === base(current.handle) && pattern(p.handle) !== pattern(current.handle);
        const higher = chosen.price > variant.price && (!pattern(current.handle) || pattern(p.handle));
        return {p,chosen,rank:paired ? 0 : higher ? 1 : match ? 2 : 3};
      }).sort((a,b) => Number(b.p.available)-Number(a.p.available) || a.rank-b.rank || b.chosen.price-a.chosen.price || a.p.handle.localeCompare(b.p.handle));
      ranked.forEach(({p,chosen},i) => {
        const card=cards.get(p.handle); if (!card) return;
        card.hidden=i>=Number(root.dataset.limit || 12);
        card.querySelectorAll('a').forEach(a => a.href=p.url+'?variant='+chosen.id);
        const img=card.querySelector('img');
        if (img && img.getAttribute('src')!==chosen.image) {img.removeAttribute('srcset');img.src=chosen.image;}
        card.querySelector('.yiri-board-recs__price').textContent=chosen.money.replace(/<[^>]*>/g,'');
        track.appendChild(card);
      });
    }
    update(root.dataset.variant);
    root.querySelector('[data-rec-prev]').addEventListener('click',()=>track.scrollBy({left:-track.clientWidth,behavior:'smooth'}));
    root.querySelector('[data-rec-next]').addEventListener('click',()=>track.scrollBy({left:track.clientWidth,behavior:'smooth'}));
    // Kalles dispatches this event with currentVariant on its jQuery event.
    const bind=()=>{if(window.jQuery_T4NT)window.jQuery_T4NT(document).on('variant:changed.yiriRecs',event=>{
      if(event.currentVariant && current.variants.some(v=>v.id===event.currentVariant.id)) update(event.currentVariant.id);
    });};
    if(document.readyState==='complete')bind();else window.addEventListener('load',bind,{once:true});
    window.addEventListener('popstate',()=>update(new URL(location.href).searchParams.get('variant')));
  }
  document.querySelectorAll('[data-yiri-board-recs]').forEach(init);
})();
